// Shared email / phone validation used by every form that creates or edits a
// record with an email or phone number.

// Pragmatic email check: a single @, non-empty local part, and a dotted domain.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean =>
  EMAIL_RE.test(email.trim());

// Phone: optional leading +, then digits/space/-/()/. — with 7–15 actual
// digits (E.164 allows at most 15).
const PHONE_SHAPE_RE = /^\+?[\d\s\-().]+$/;

export const isValidPhone = (phone: string): boolean => {
  const value = phone.trim();
  if (!PHONE_SHAPE_RE.test(value)) return false;
  const digits = value.replace(/\D/g, "");
  return digits.length >= 7 && digits.length <= 15;
};

/**
 * Returns an error message for an email field, or `null` when valid.
 * @param required when true (default) an empty value is an error.
 */
export const validateEmail = (
  email: string,
  required = true,
): string | null => {
  const value = email.trim();
  if (!value) return required ? "Email is required." : null;
  if (!isValidEmail(value)) return "Enter a valid email address.";
  return null;
};

/**
 * Returns an error message for a phone field, or `null` when valid.
 * @param required when true an empty value is an error (defaults to false —
 *        phone is usually optional).
 */
export const validatePhone = (
  phone: string,
  required = false,
): string | null => {
  const value = phone.trim();
  if (!value) return required ? "Phone number is required." : null;
  if (!isValidPhone(value)) return "Enter a valid phone number.";
  return null;
};
